import LoadingPage from "components/LoadingPage"
import useAuth from "hooks/useAuth"
import { useState } from "react"
import { useLocation, Navigate } from "react-router-dom"
import PropTypes from "prop-types"

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth()
  const { pathname } = useLocation()
  const [requestLocation, setRequestLocation] = useState(null)
  if (!isInitialized) {
    return <LoadingPage />
  }
  if (!isAuthenticated) {
    if (requestLocation !== pathname) {
      setRequestLocation(pathname)
    }
    return <Navigate to="/auth/login" replace />
  }
  if (requestLocation && pathname !== requestLocation) {
    setRequestLocation(null)
    return <Navigate to={requestLocation} />
  }

  return <>{children}</>
}

AuthGuard.propTypes = {
  children: PropTypes.node
}
